// taken from here: https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export default function numHash(str: string) {
  if (str.length === 0) return 0;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
